(function () {
  'use strict';

  function initDeviceColorPicker(pickerEl) {
    const productInfoMedia = pickerEl.closest('.xo-product-info-media') ||
      document.querySelector('.xo-product-info-media');
    if (!productInfoMedia) return;

    const firstSwatch = pickerEl.querySelector('[data-device-color]');
    if (firstSwatch) {
      applyColor(firstSwatch.dataset.deviceColor, productInfoMedia);
    }

    pickerEl.querySelectorAll('[data-device-color]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        applyColor(swatch.dataset.deviceColor, productInfoMedia);
        pickerEl.querySelectorAll('[data-device-color]').forEach(function (s) {
          s.classList.remove('xo-device-color-swatch--active');
          s.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('xo-device-color-swatch--active');
        swatch.setAttribute('aria-pressed', 'true');
      });
    });

    // Thumbnail click delegation on stable container — survives carousel reconnects
    if (!productInfoMedia._thumbDelegated) {
      productInfoMedia._thumbDelegated = true;
      productInfoMedia.addEventListener('click', function (e) {
        var thumbList = productInfoMedia.querySelector('xo-carousel-thumbnail xo-carousel-list');
        if (!thumbList) return;
        var slide = e.target.closest('xo-carousel-slide');
        if (!slide || !thumbList.contains(slide)) return;
        var slides = Array.from(thumbList.querySelectorAll(':scope > xo-carousel-slide'));
        var index = slides.indexOf(slide);
        if (index < 0) return;
        var carousel = productInfoMedia.querySelector('xo-carousel');
        if (!carousel || !carousel.xoName || !window.xoCarousel) return;
        window.xoCarousel.goTo(carousel.xoName, index);
      });
    }
  }

  function applyColor(color, productInfoMedia) {
    productInfoMedia.querySelectorAll('xo-carousel-list').forEach(function (list) {
      if (list._removedSlides) {
        list._removedSlides.forEach(function (entry) {
          if (entry.nextSibling && entry.nextSibling.parentNode === list) {
            list.insertBefore(entry.slide, entry.nextSibling);
          } else {
            list.appendChild(entry.slide);
          }
        });
        list._removedSlides = null;
      }

      var toRemove = [];
      Array.from(list.querySelectorAll(':scope > xo-carousel-slide')).forEach(function (slide) {
        const sc = slide.getAttribute('data-device-color');
        const show = !sc || sc === 'universal' || sc === color;
        if (!show) {
          toRemove.push({ slide: slide, nextSibling: slide.nextSibling });
        }
      });

      list._removedSlides = toRemove;
      toRemove.forEach(function (entry) {
        list.removeChild(entry.slide);
      });
    });

    setTimeout(function () {
      productInfoMedia.querySelectorAll('xo-carousel').forEach(function (el) {
        const parent = el.parentNode, next = el.nextSibling;
        if (parent) { parent.removeChild(el); parent.insertBefore(el, next); }
      });
      productInfoMedia.querySelectorAll('xo-gallery').forEach(function (el) {
        const parent = el.parentNode, next = el.nextSibling;
        if (parent) { parent.removeChild(el); parent.insertBefore(el, next); }
      });

      setTimeout(function () {
        var carousel = productInfoMedia.querySelector('xo-carousel');
        if (carousel && carousel.xoName && window.xoCarousel) {
          window.xoCarousel.goTo(carousel.xoName, 0);
        }
        applyCarouselFixes(productInfoMedia);

        // Trigger autoplay on video in first slide after color switch
        setTimeout(function () {
          productInfoMedia.querySelectorAll('video').forEach(function (video) {
            video.play().catch(function () {});
          });
        }, 200);
      }, 100);
    }, 20);
  }

  function applyCarouselFixes(container) {
    var mainList = container.querySelector('xo-carousel > xo-carousel-inner > xo-carousel-list');
    if (mainList && !mainList._dragFixed) {
      mainList._dragFixed = true;
      mainList.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
      }, true);
      mainList.style.cursor = 'default';
    }
  }

  window._euclidApplyCarouselFixes = applyCarouselFixes;

  function init() {
    document.querySelectorAll('[data-device-color-picker]').forEach(initDeviceColorPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(init, 100); });
})();